import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Form = () => {
  const [formData, setFormData] = useState({
    file: null,
    fullName: '',
    email: '',
    githubUsername: '',
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  
  const handleFileChange = (e) => {
    const file = e.target.files[0];  
    setFormData({
      ...formData,
      file: file,
    });

    const reader = new FileReader();
    reader.onloadend = () => {
      sessionStorage.setItem('uploadedFile', reader.result);  
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();  
    console.log('Form data submitted:', formData);
    navigate("/ticket", { state: formData })
  };

  

  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <form className="flex flex-col justify-center items-center mt-6 space-y-4" onSubmit={handleSubmit}>
 
      <div className="w-full md:w-1/2 lg:w-1/3 px-4 md:px-0">
        <label htmlFor="file" className="block text-lg font-medium mb-2">Upload File</label>
        <div className="relative mt-2">
          <input
            type="file"
            id="file"
            ref={fileInputRef}
            className="hidden"
            onChange={handleFileChange}
          />
          <div
            onClick={handleClick}
            className="flex items-center justify-center px-4 py-8 border-2 border-dashed border-gray-300 rounded-md cursor-pointer hover:bg-gray-700"
          >
            <span className="text-gray-300 ">
              {formData.file ? formData.file.name : "Click to upload a File"}
            </span>
          </div>
        </div>
      </div>

      <div className="w-full md:w-1/2 lg:w-1/3 px-4 md:px-0">
        <label htmlFor="fullName" className="block text-lg font-medium mb-2">Full Name</label>
        <input
          type="text"
          id="fullName"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          required
          className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-gray-700"
        />
      </div>

      <div className="w-full md:w-1/2 lg:w-1/3 px-4 md:px-0">
        <label htmlFor="email" className="block text-lg font-medium mb-2">Email Address</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-gray-700"
        />
      </div>


      <div className="w-full md:w-1/2 lg:w-1/3 px-4 md:px-0">
        <label htmlFor="githubUsername" className="block text-lg font-medium mb-2">GitHub Username</label>
        <input
          type="text"
          id="githubUsername"
          name="githubUsername"
          value={formData.githubUsername}
          onChange={handleChange}
          required
          className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-gray-700"
        />
      </div>

      <button
        type="submit"
        style={{ backgroundColor: 'hsl(7, 88%, 67%)', hover: { backgroundColor: 'hsl(7, 71%, 60%)' } }}
        className="w-full md:w-1/2 lg:w-1/3 py-2 text-white font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
      >
        Generate My Ticket
      </button>
    </form>
  );
};

export default Form;
